import { uniqueId } from "lodash";

export const getInputId = (inputName: string) =>
  `${uniqueId(Date.now().toString())}-${inputName}`;
